import request from '@nineeng/request';
import { AuthenticationSession } from '@repo/shared/domain';

export async function getConfig() {
	const response = await request.get<Config>(`/api/config`);
	return response.body;
}
